import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { LocalStorageService } from './local-storage-service';

@Injectable({
  providedIn: 'root'
})
export class RetrieveStaticDocumentSets {

  constructor(
    private _http: HttpClient,
    private _localStorageService: LocalStorageService
  ) { }

  private getDepartmentFromLocalStorage(): string {
    return this._localStorageService.getItem('selectedDepartment');
  }
  
  getAllStaticDocumentSets() {
    const department = this.getDepartmentFromLocalStorage();

    return this._http.get(`${environment.api}/api/v1/staticdocumentset?department=${department}`);
  }

}
